<template>
  <div>
    <!-- 性别比例 -->
    <Echart :options="options" height="340px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    Ldata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    Ldata: {
      handler(newData) {
        let colorList = ['#3399ff', '#ff3399'];
        this.options = {
          grid: {
            bottom: 150,
            left: 0,
            right: '10%'
          },
          legend: {
            show: false
          },
          series: [
            {
              radius: '50%',
              center: ['50%', '50%'],
              itemStyle: {
                normal: {
                  color: function (params) {
                    return colorList[params.dataIndex];
                  }
                }
              },
              hoverAnimation: false, // 鼠标经过放大动画
              labelLine: {
                normal: {
                  show: false,
                  length: 15,
                  length2: 120,
                  lineStyle: {
                    color: '#d3d3d3'
                  },
                  align: 'center'
                },
                color: '#000',
                emphasis: {
                  show: true
                }
              },
              label: {
                normal: {
                  formatter: function (params) {
                    var str = params.name + ': ' + params.value + '%';
                    return str;
                  },
                  fontSize: 16,
                  position: 'inner'
                }
              },
              type: 'pie',
              data: newData.data
            },
            {
              radius: ['50%', '52%'],
              center: ['50%', '50%'],
              type: 'pie',
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              animation: false,
              tooltip: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: '#ffffff'
                }
              },
              data: [
                {
                  value: 1
                }
              ]
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
